Vue.component('auth-wrapper-form', () => import(/* webpackChunkName: "auth-wrapper-form" */ '@/Auth/WrapperForm'))

Vue.component('register-form', () => import(/* webpackChunkName: "register-form" */ '@/Auth/RegisterForm'))
Vue.component('login-form', () => import(/* webpackChunkName: "login-form" */ '@/Auth/LoginForm'))
Vue.component('dropdown-login-form', () => import(/* webpackChunkName: "dropdown-login-form" */ '@/Auth/DropdownLoginForm'))
Vue.component('verify-email-form', () => import(/* webpackChunkName: "verify-email-form" */ '@/Auth/VerifyEmailForm'))
Vue.component('forgot-password-form', () => import(/* webpackChunkName: "forgot-password-form" */ '@/Auth/ForgotPasswordForm'))
Vue.component('reset-password-form', () => import(/* webpackChunkName: "reset-password-form" */ '@/Auth/ResetPasswordForm'))
Vue.component('logout-form', () => import(/* webpackChunkName: "logout-form" */ '@/Auth/LogoutForm'))


Vue.component('register-form2', () => import(/* webpackChunkName: "register-form2" */ '@/Auth/RegisterForm2'))
